import Db_cube from "../../../database/admin/db_cube";
import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import ModalWindow from "../../modal";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Collapse,
    DatePicker,
    Popconfirm,
    Row,
    Select,
    Space,
    Steps,
    Typography
} from "antd";
import {Outlet} from "react-router-dom";
import DB_Branch from "../../../database/dictionary/branch";

const Cube = () => {
    const {t} = useTranslation();
    const {token, locale, setToken} = useContext(Context);
    const {getCheckCub, startCub, stopCub, clearSaleCub} = Db_cube(token)
    const {getActiveBranches} = DB_Branch(token)
    const {errorConnect} = ModalWindow();
    const [wait, setWait] = useState(true)
    const controller = new AbortController();
    const [step, setStep] = useState(0)
    const [error, setError] = useState(false)
    const [errorDescription, setErrorDescription] = useState(null)
    const [branches, setBranches] = useState([])
    const [selectedBranch, setSelectedBranch] = useState()
    const [selectedDate, setSelectedDate] = useState([])
    const [runnedCube, setRunnedCube] = useState(false)
    const [statusCube, setStatusCube] = useState('wait')


    const startsCub = () => {
        startCub(controller)
            .then(res => {
                setStep(0)
                setError(false)
                setRunnedCube(true)
                setErrorDescription(null)
                setStatusCube('wait')
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }

    const stopssCub = () => {
        stopCub(controller)
            .then(res => {
                setStep(2)
                setError(true)
                setRunnedCube(false)
                setErrorDescription(t('canceled'))
                setStatusCube('finish')
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }

    useEffect(() => {
        window.scroll(0, 0)
        getCheckCub(controller)
            .then(res => {
                if (res.data.status === 'Success') {
                    setStep(2)
                    setStatusCube('finish')
                } else if (res.data.status === 'Canceled') {
                    setStep(2)
                    setError(true)
                    setErrorDescription(t('canceled'))
                    setStatusCube('finish')
                } else if (res.data.status === 'FAILED') {
                    setStep(2)
                    setError(true)
                    setErrorDescription(t('failed'))
                    setStatusCube('error')
                } else {
                    if (res.data.step == null) {
                        setStep(1)
                    } else {
                        setStep(res.data.step - 1)
                    }
                    setRunnedCube(true)
                    // setStep(res.data.step - 1)
                    setStatusCube('wait')
                }
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }, [])

    useEffect(() => {
        getActiveBranches()
            .then(res => {
                setBranches(res.data)
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }, [])

    const deleteSales = () =>
        new Promise(resolve => {
            const formData = new FormData()
            formData.append('branch_id', selectedBranch)
            formData.append('date_from', selectedDate[0])
            formData.append('date_to', selectedDate[1])

            clearSaleCub(formData)
                .then(res => {
                    resolve(null)
                })
                .catch(e => {
                    resolve(null)
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
        }).then(r => {

        })



    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('cube')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <Button danger shape={'round'} disabled={!runnedCube} onClick={stopssCub} key={1}>{t('stop_cube')}</Button>,
                        <Button shape={'round'} loading={step !== 2} onClick={startsCub} key={2}>{t('start_cube')}</Button>,
                    </Space>
                </Space>


                <Card>
                    <Typography.Title level={5}>{t('status_cube')}</Typography.Title>
                    <Steps
                        current={step}
                    >
                        <Steps.Step title={t('etl')}/>
                        <Steps.Step title={t('processing_cube')}/>
                        {/*{error ? <Steps.Step title={t('end')} status={'error'} description={errorDescription}/> : <Steps.Step title={t('end')} status={'finish'}/>}*/}
                         <Steps.Step title={t('end')} status={statusCube} description={errorDescription}/>
                    </Steps>

                    <br/>
                    <br/>
                    <br/>
                    <Typography.Title level={5}>{t('quick_commands')}</Typography.Title>

                    <Collapse accordion>
                        <Collapse.Panel header={t('clear_sales')} key="1">
                            <Row gutter={12}>
                                <Col>
                                    <DatePicker.RangePicker
                                        onChange={e => setSelectedDate([e[0].format('yyyy-MM-DD'), e[1].format('yyyy-MM-DD')])}/>
                                </Col>
                                <Col>
                                    <Select style={{width: '200pt'}} onChange={e => setSelectedBranch(e)}>
                                        {branches.map(b =>
                                            <Select.Option key={b.id} value={b.id}>{b.name}</Select.Option>
                                        )}
                                    </Select>
                                </Col>
                                <Col>
                                    <Popconfirm title={t('sure?')} onConfirm={deleteSales}>
                                        <Button>{t('start')}</Button>
                                    </Popconfirm>
                                </Col>
                            </Row>

                        </Collapse.Panel>
                    </Collapse>

                </Card>

            </div>
            <Outlet/>

        </>
    )
}

export default Cube;